<mat-form-field *transloco="let t" appearance="standard" class="w-100">
    <mat-label>{{ t('fields.string-value', { type: type }) }}</mat-label>
    <span matPrefix class="me-1" *ngIf="prefix">{{ prefix }}</span>
    <input matInput [formControl]="innerControl" [attr.type]="type" [placeholder]="t('general.enter-value')" />
    <mat-error>
        <td-validation-messages [control]="innerControl" [context]="{ name: key }"></td-validation-messages>
    </mat-error>
</mat-form-field>
